import { tv } from 'tailwind-variants'

export const emptyState = tv({
  slots: {
    containerStyle: 'flex h-full w-full flex-col flex-nowrap items-center justify-center gap-3',
    iconContainerStyle: 'flex items-center justify-center rounded-full bg-brand-primary-light-00',
    iconStyle: 'text-brand-primary-rest',
    contentStyle: 'flex flex-col items-center justify-center',
    titleStyle: 'text-center title-extra-small text-neutral-primary',
    messageStyle: 'text-center body-small-basic text-neutral-secondary',
    childrenStyle: 'flex items-center justify-center gap-3',
  },
  variants: {
    iconType: {
      regular: {
        iconStyle: 'fa-regular text-brand-primary-rest',
      },
      solid: {
        iconStyle: 'fa-solid text-brand-primary-rest',
      },
    },
  },
  defaultVariants: {
    iconType: 'regular',
  },
})
